import { render, staticRenderFns } from "./LivroEstrelaIcon.vue?vue&type=template&id=8aacea6c&scoped=true"
import script from "./LivroEstrelaIcon.vue?vue&type=script&lang=js"
export * from "./LivroEstrelaIcon.vue?vue&type=script&lang=js"
import style0 from "./LivroEstrelaIcon.vue?vue&type=style&index=0&id=8aacea6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aacea6c",
  null
  
)

export default component.exports